<template>
  <form action="javascript:;">
    <div class="modal-window-header gray">
      <div class="modal-window-heading">
        <h3>{{theTitle}}</h3>
        <br>
      </div>
    </div>
    <div class="modal-window-body gray">
      <p>
        <span class="opacity-80" v-html="theText">{{theText}}</span>
      </p>
    </div>
    <div class="modal-window-footer">
      <div class="grid-x">
        <div class="cell align-right">
          <button href="javascript:;" class="button primary transparent modal-close" @click="onConfirmCancel()">
            {{cancelButtonText}}
          </button>
          <button v-if="!okConfirmRunning" href="javascript:;" class="button primary submit" @click="onConfirmOk()">
            <span>{{okButtonText}}</span>
          </button>
          <button v-else href="javascript:;" class="button primary submit loading">
            <span>{{okButtonText}} <span class="loader-spinner"></span></span>
          </button>
        </div>
      </div>
    </div>

    <a href="javascript:;" class="modal-close modal-window-close-button" @click="closeButtonClick()">
      <span>Lukk</span>
      <svg width="16px" height="16px" viewBox="0 0 16 16"><use xlink:href="/static/sprites.svg#button-glyph-close"></use></svg>
    </a>
  </form>
</template>

<script>
import bus from '@/plugins/event-bus'

export default {
  name: 'TheConfirm',
  props: {
    theTitle: {
      type: String,
      required: true
    },
    theText: {
      type: String,
      required: true
    },
    cancelButtonText: {
      type: String,
      required: false,
      default () {
        return 'Avbryt'
      }
    },
    okButtonText: {
      type: String,
      required: false,
      default () {
        return 'Ok'
      }
    },
    okCallback: {
      type: Function,
      required: false
    },
    cancelCallback: {
      type: Function,
      required: false
    }
  },
  data () {
    return {
      okConfirmRunning: false
    }
  },
  mounted () {
    this.okConfirmRunning = false
  },
  methods: {
    closeButtonClick: function () {
      this.closeModal()
    },
    onConfirmCancel: function () {
      if (this.cancelCallback) {
        this.cancelCallback()
      } else {
        bus.$emit('confirm-action', { pressed: false })
      }
    },
    onConfirmOk: function () {
      this.okConfirmRunning = true

      if (this.okCallback) {
        this.okCallback()
      } else {
        bus.$emit('confirm-action', { pressed: true })
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/TheConfirm.vue